import { cdpClient } from '../client';
import type {
  Transition,
  TransitionCreate,
  TransitionStep,
  TransitionStepCreate,
  TransitionStepUpdate,
  TransitionUpdate,
} from '../types';

function requireProjectId(projectId: string | null | undefined): string {
  const id = (projectId ?? '').trim();
  if (!id) throw new Error('Выберите проект');
  return id;
}

export async function listTransitions(
  projectId: string,
  includeSteps = true,
): Promise<Transition[]> {
  const id = requireProjectId(projectId);
  const { data, error } = await cdpClient.GET('/projects/{project_id}/transitions', {
    params: {
      path: { project_id: id },
      query: { include_steps: includeSteps },
    },
  });
  if (error) throw error;
  return data?.items ?? [];
}

export async function createTransition(
  projectId: string,
  body: TransitionCreate,
): Promise<Transition> {
  const id = requireProjectId(projectId);
  const { data, error } = await cdpClient.POST('/projects/{project_id}/transitions', {
    params: { path: { project_id: id } },
    body,
  });
  if (error) throw error;
  if (!data) throw new Error('Пустой ответ API');
  return data;
}

export async function updateTransition(
  projectId: string,
  transitionId: string,
  body: TransitionUpdate,
): Promise<Transition> {
  const id = requireProjectId(projectId);
  const { data, error } = await cdpClient.PATCH(
    '/projects/{project_id}/transitions/{transition_id}',
    {
      params: { path: { project_id: id, transition_id: transitionId } },
      body,
    },
  );
  if (error) throw error;
  if (!data) throw new Error('Пустой ответ API');
  return data;
}

export async function deleteTransition(projectId: string, transitionId: string): Promise<void> {
  const id = requireProjectId(projectId);
  const { error } = await cdpClient.DELETE(
    '/projects/{project_id}/transitions/{transition_id}',
    {
      params: { path: { project_id: id, transition_id: transitionId } },
    },
  );
  if (error) throw error;
}

export async function listTransitionSteps(
  projectId: string,
  transitionId: string,
): Promise<TransitionStep[]> {
  const id = requireProjectId(projectId);
  const { data, error } = await cdpClient.GET(
    '/projects/{project_id}/transitions/{transition_id}/steps',
    {
      params: {
        path: { project_id: id, transition_id: transitionId },
      },
    },
  );
  if (error) throw error;
  return Array.isArray(data) ? data : [];
}

export async function createTransitionStep(
  projectId: string,
  transitionId: string,
  body: TransitionStepCreate,
): Promise<TransitionStep> {
  const id = requireProjectId(projectId);
  const { data, error } = await cdpClient.POST(
    '/projects/{project_id}/transitions/{transition_id}/steps',
    {
      params: {
        path: { project_id: id, transition_id: transitionId },
      },
      body,
    },
  );
  if (error) throw error;
  if (!data) throw new Error('Пустой ответ API');
  return data;
}

export async function updateTransitionStep(
  projectId: string,
  transitionId: string,
  stepId: string,
  body: TransitionStepUpdate,
): Promise<TransitionStep> {
  const id = requireProjectId(projectId);
  const { data, error } = await cdpClient.PATCH(
    '/projects/{project_id}/transitions/{transition_id}/steps/{step_id}',
    {
      params: {
        path: {
          project_id: id,
          transition_id: transitionId,
          step_id: stepId,
        },
      },
      body,
    },
  );
  if (error) throw error;
  if (!data) throw new Error('Пустой ответ API');
  return data;
}

export async function deleteTransitionStep(
  projectId: string,
  transitionId: string,
  stepId: string,
): Promise<void> {
  const id = requireProjectId(projectId);
  const { error } = await cdpClient.DELETE(
    '/projects/{project_id}/transitions/{transition_id}/steps/{step_id}',
    {
      params: {
        path: {
          project_id: id,
          transition_id: transitionId,
          step_id: stepId,
        },
      },
    },
  );
  if (error) throw error;
}
